import { ButtonGroup, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { FEATURE_FUNCTION_SELECTION } from "../../../Constant/FeatureSelection";
import { getStatusData, STATUS_DATA_TYPE } from "../../../Constant/StatusData";
import { getDarkDropdown, getStatusBadge } from "../../../Utils/otherFunctions";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import { admins } from "../../../Constant";
import { getUser } from "../../../Utils/externalFunctions";
import { Edit, Trash2 } from "react-feather";

const DaftarAkunColumns = (themeContext, handleEditStatus, handleDeleteAkun) => {
  
  const columns = [
    {
      name: <DataTableTitle text={"Kode Akun"} />,
      selector: (row) => row.pk,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"DPSJ"} />,
      selector: (row) => row.nm_org,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Kegiatan"} />,
      sortable: true,
      selector: (row) => row.kd_keg + " - " + row.nm_keg,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Akun"} />,
      selector: (row) => row.kd_akun + " - " + row.nm_akun,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Status"} />,
      selector: (row) => {
        const statusData = getStatusData(
          row.status_akun,
          STATUS_DATA_TYPE.AkunBaru
        );
        return getStatusBadge(statusData);
      },
      sortable: true,
    },
  ];

  if (FEATURE_FUNCTION_SELECTION.AkunBaru.Operasi) {
    columns.push({
      name: <DataTableTitle text={"Operasi"} />,
      cell: (row) => (
        <ButtonGroup>
          <UncontrolledDropdown>
            <DropdownToggle caret></DropdownToggle>
            <DropdownMenu>
              {FEATURE_FUNCTION_SELECTION.AkunBaru.UpdateStatus &&
                admins.includes(getUser()) && (
                  <DropdownItem
                    className={`d-flex align-items-center gap-2 ${getDarkDropdown(
                      themeContext
                    )}`}
                    onClick={() => handleEditStatus(row)}
                  >
                    <Edit size={12} />
                    Edit Status
                  </DropdownItem>
                )}
              {FEATURE_FUNCTION_SELECTION.AkunBaru.Delete && (
                <DropdownItem
                  className={`d-flex align-items-center gap-2 text-danger ${getDarkDropdown(
                    themeContext
                  )}`}
                  onClick={() => handleDeleteAkun(row)}
                >
                  <Trash2 size={12} />
                  Hapus
                </DropdownItem>
              )}
            </DropdownMenu>
          </UncontrolledDropdown>
        </ButtonGroup>
      ),
    });
  }

  return columns;};

export default DaftarAkunColumns;